export type ContributorApplication = {
  hasApplication: boolean;
  role?: string;
  displayStatus?: string | null;
  approvalStatus?: string | null;
  rejectionReason?: string | null;
};

export const canSubmitContributorApplication = (app?: ContributorApplication | null) => {
  if (!app?.hasApplication) return true;
  return /^rejected$/i.test(app.approvalStatus || app.displayStatus || '');
};

export const contributorStatusLabel = (app?: ContributorApplication | null) =>
  app?.displayStatus || app?.approvalStatus || 'Pending Review';

export const isApprovedContributor = (app?: ContributorApplication | null) =>
  /^approved$/i.test(app?.displayStatus || app?.approvalStatus || '');
